import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { dashboardVariantForRole } from "../lib/dashboardRole";
import GuardDashboard from "./dashboards/GuardDashboard";
import WeighbridgeDashboard from "./dashboards/WeighbridgeDashboard";
import LabDashboard from "./dashboards/LabDashboard";
import AccountsDashboard from "./dashboards/AccountsDashboard";
import StoreKeeperDashboard from "./dashboards/StoreKeeperDashboard";
import SupervisorDashboard from "./dashboards/SupervisorDashboard";
import UnloadingSupervisorDashboard from "./dashboards/UnloadingSupervisorDashboard";
import ProductionLoadingSupervisorDashboard from "./dashboards/ProductionLoadingSupervisorDashboard";
import PurchaserDashboard from "./dashboards/PurchaserDashboard";
import OperationsDashboard from "./dashboards/OperationsDashboard";
import DepartmentDashboard from "./production/DepartmentDashboard";
import { isDepartmentForeman } from "../lib/dashboardRole";

function makeDepartmentHomeDashboard(department) {
  return function DepartmentHomeDashboard() {
    const { user } = useAuth();
    if (!isDepartmentForeman(user?.role)) {
      return <Navigate to={`/production/${department}`} replace />;
    }
    return <DepartmentDashboard department={department} />;
  };
}

const DASHBOARDS = {
  guard: GuardDashboard,
  weighbridge: WeighbridgeDashboard,
  lab: LabDashboard,
  accounts: AccountsDashboard,
  store_keeper: StoreKeeperDashboard,
  supervisor: SupervisorDashboard,
  unloading_supervisor: UnloadingSupervisorDashboard,
  production_loading_supervisor: ProductionLoadingSupervisorDashboard,
  purchaser: PurchaserDashboard,
  operations: OperationsDashboard,
  dept_boiler: makeDepartmentHomeDashboard("boiler"),
  dept_parboiled: makeDepartmentHomeDashboard("parboiled"),
  dept_milling: makeDepartmentHomeDashboard("milling"),
};

export default function DashboardPage() {
  const { user } = useAuth();
  const variant = dashboardVariantForRole(user?.role);
  const View = DASHBOARDS[variant] || OperationsDashboard;

  return <View />;
}
